/*
 * @Author: caizexin caizexin@kjgb.net
 * @Date: 2022-11-22 17:11:27
 */
import { Data } from '@/api/axiosFun.js';

class DashboardApi {
    static getInstance() {
        if (!this.instance) this.instance = new DashboardApi()
        return this.instance
    }

    // 获取数据
    async getData(url, param, method, dataType) {
        let result = await Data.getInstance().getData(url, param, method, dataType)
        return result
    }

    // 获取订单总数
    async getOrderCount (param){
        let url = `/api/order/head/order/count`
        let result = await this.getData(url,param,'POST')
        return result
    }

    // 获取整车销量 
    async getBikeCount (param){
        let url = `/api/order/head/bike/count`
        let result = await this.getData(url,param,'GET')
        return result
    }

    // 获取整车退货数量
    async getRecordCount (param){
        let url = `/api/order/back/record/bike/count`
        let result = await this.getData(url,param,'GET')
        return result
    } 

    // 获取整车发货数量
    async getStockOutCount (param){
        let url = `/api/order/stock/out/count`
        let result = await this.getData(url,param,'GET')
        return result
    } 

    // 获取整车已付款未发货数量/全额退款数量/取消数量/未付款数量
    async getHeadCount (param){
        let url = `/api/order/head/count`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 获取整车未付款未发货数量
    async getNoPaidShipCount (param){
        let url = `/api/order/head/no/paid/ship/count`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 获取整车超期未付款未发货数量
    async getOverdueCount (param){
        let url = `/api/order/head/overdue/count`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 获取已出库整车数量   
    async getShipCount (param){
        let url = `/api/order/head/ship/count`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 获取及时交付率
    async getDeliveryCount (param){
        let url = `/api/order/head/delivery/count`
        let result = await this.getData(url,param,'GET')
        return result
    } 

    // 获取仓库下拉
    async getWarehouse(){
        let url = `/api/order/warehouse`
        let result = await this.getData(url,{},'GET')
        return result
    }

    // 获取订单来源
    async getOrderSource (param){
        // let url = `/api/system/source`
        // let result = await this.getData(url,param,'GET')
        // return result

        let url = `/api/system/source/query`
        let result = await this.getData(url,param,'POST')
        return result
    } 

    // 获取订单来源
    async getProductCategory (){
        let url = `/api/product/category`
        let result = await this.getData(url,{},'GET')
        return result
    } 

     // 导出交付率明细
     async export (param){
        let url = `/api/order/head/export/stock/out`
        let result = await this.getData(url,param,'GET')
        return result
    } 
}

export {
    DashboardApi
}